import initialState from './initialState';
import fileSaver from 'file-saver';
import {
  RECEIVE_PIPELINE,
  PAGINATE_PIPELINE,
  EXPORT_AND_SAVE_PIPELINE,
  HANDLE_PIPELINE_ERROR
} from '../actions/actionTypes';

export function pipeline(state = initialState.pipeline, action) {
  switch (action.type) {
    case RECEIVE_PIPELINE:
      return action.pipeline;
    case EXPORT_AND_SAVE_PIPELINE:
      fileSaver.saveAs(
        new Blob([action.data], { type: "text/csv" }),
        "export.csv"
      );
      return state;
    default:
      return state;
  }
}

export function pipelineError(state = initialState.pipelineError, action) {
  switch (action.type) {
    case HANDLE_PIPELINE_ERROR:
      return action.pipelineError;
    default:
      return state;
  }
}

export function pipelinePagination(state = initialState.pipelinePagination, action) {
  switch (action.type) {
    case PAGINATE_PIPELINE:
      return action.pipelinePagination;
    default:
      return state;
  }
}
